import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.account_history_table.title',
        defaultMessage: '{accountType} transaction history'
    },
    noTransactions: {
        id: '_.account_history_table.no_transactions',
        defaultMessage: 'No transactions yet!'
    },
    date: {
        id: '_.account_history_table.date',
        defaultMessage: 'Date'
    },
    principal: {
        id: '_.account_history_table.principal',
        defaultMessage: 'Principal'
    },
    interest: {
        id: '_.account_history_table.interest',
        defaultMessage: 'Interest / Fees'
    },
    balance: {
        id: '_.account_history_table.balance',
        defaultMessage: 'Closing\nBalance'
    },
    download: {
        id: '_.account_history_table.download_button',
        defaultMessage: 'Download'
    },
    accountStatement: {
        id: '_.account_history_table.account_statement_button',
        defaultMessage: 'Account statement'
    },

    fundingHistory: {
        id: '_.account_history_table.funding_history_button',
        defaultMessage: 'Funding history'
    }
});
